import LotList from '@/components/lot/LotList'
import LotCreate from '@/components/lot/LotCreate'
import LotVue from '@/components/lot/LotVue'
import LotEdit from '@/components/lot/LotEdit'
import ExternalEdit from '@/components/lot/ExternalEdit'
import LotDocumentEdit from '@/components/lot/LotDocumentEdit'
import LotWishlistList from '@/components/lot/LotWishlistList'

export default [
  {
    path: '/lots',
    name: 'LotList',
    component: LotList,
    meta: {
      parentName: 'Home',
      requiresAuth: true
    }
  },
  {
    path: '/lots/creation',
    name: 'LotCreate',
    component: LotCreate,
    meta: {
      parentName: 'StockLots',
      requiresAuth: true,
      needProfile: ['admin', 'editor']
    }
  },
  {
    path: '/lots/favoris',
    name: 'LotWishlistList',
    component: LotWishlistList,
    meta: {
      parentName: 'StockLots',
      requiresAuth: true
    }
  },
  {
    path: '/lots/:id/edition',
    name: 'LotEdit',
    component: LotEdit,
    meta: {
      parentName: 'LotVue',
      requiresAuth: true,
      needProfile: ['admin', 'editor']
    }
  },
  {
    path: '/lots/:id/documents',
    name: 'LotDocumentEdit',
    component: LotDocumentEdit,
    meta: {
      parentName: 'LotVue',
      requiresAuth: true,
      needProfile: ['admin', 'editor']
    }
  },
  {
    path: '/lots/:id/vente-externe',
    name: 'ExternalEdit',
    component: ExternalEdit,
    meta: {
      parentName: 'LotVue',
      requiresAuth: true
    }
  },
  {
    path: '/lots/:id',
    name: 'LotVue',
    component: LotVue,
    meta: {
      parentName: 'StockLots',
      requiresAuth: true,
      maxHeight: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/lotRouter.js